var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BadRequestError } from '@lucidlink/sdk/fetcher';
import { translate, useToastService } from '@lucidlink/uicore';
import { useWorkspaceSsoLogin, } from '@lucidlink/workspacemanagement';
export const useOnAuthCodeReceived = (exchangeCode) => {
    _react_refresh_temp_1();
    const { workspaceId = '' } = useParams();
    const navigate = useNavigate();
    const { addToast } = useToastService();
    const onSsoLogin = useCallback(() => void navigate(`/workspaces/${workspaceId}`), [navigate, workspaceId]);
    const onSsoLoginFail = useCallback((e) => {
        if (e instanceof BadRequestError &&
            e.errors[0]?.code === 'workspaceLogin.emailMismatch') {
            addToast({
                'data-testid': 'workspace-sso-login-fail',
                content: {
                    label: translate('Already logged in with a different email.'),
                    message: translate('Please log out and try again.'),
                },
                kind: 'negative',
            });
        }
        else {
            addToast({
                'data-testid': 'workspace-sso-login-fail',
                content: {
                    label: translate('SSO authentication failed.'),
                    message: translate('Please try again.'),
                },
                kind: 'negative',
            });
        }
    }, [addToast]);
    const { mutate: ssoLogin } = useWorkspaceSsoLogin({
        onSuccess: onSsoLogin,
        onError: onSsoLoginFail,
    });
    const onAuthCodeReceived = useCallback(async (message) => {
        if (message.type !== 'auth-code-received') {
            return;
        }
        const tokenEndpointResponse = await exchangeCode(message.payload);
        if (!tokenEndpointResponse?.access_token) {
            return;
        }
        ssoLogin({
            workspaceId,
            accessToken: tokenEndpointResponse.access_token,
        });
    }, [exchangeCode, ssoLogin, workspaceId]);
    return onAuthCodeReceived;
};
_react_refresh_temp_1(useOnAuthCodeReceived, "Aq8317iH3jN1O1xTSCoaspHQyhc=", false, () => [useParams, useNavigate, useToastService, useWorkspaceSsoLogin]);
